var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wrapper",
      attrs: { id: "sideBarModalComponent" },
      on: { click: _vm.onClose },
    },
    [
      _c("div", { class: { wrapper_body: true, open: _vm.modalData.open } }, [
        _c(
          "div",
          { staticClass: "p-2" },
          [_c("edit", { attrs: { invoiceId: _vm.modalData.invoiceId } })],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }